<template>
    <el-dialog title="回放记录" :visible.sync="showTag" :append-to-body="true">
        <el-table size="mini" :data="list" border>
            <el-table-column property="_startTime" label="开始时间" width="200"></el-table-column>
            <el-table-column property="_endTime" label="结束时间" width="200"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="{row}">
                    <el-button type="primary" size="mini" @click="handler('show',row)">查看</el-button>
                    <el-button size="mini" @click="handler('download',row)">下载</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
  import {timeFormat} from "../../lib/utils";

  export default {
    name: "wlmz-record-list-dialog",
    data() {
      return {
        list: [],
        showTag: false
      }
    },
    methods: {
      handler(type, data) {
        if (type === 'show') window.open(data.playUrl);
        else if (type === 'download') window.open(data.downUrl);
      },
      show(list) {
        this.list = list.map(r => {
          let str = '%Y-%m-%d %H:%M:%S';
          r._startTime = timeFormat(r.startTime, str);
          r._endTime = timeFormat(r.endTime, str);
          return r;
        });
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      }
    },
  }
</script>

<style scoped>

</style>
